export default __webpack_public_path__ + "static/media/T_Tesoura.57c3857f.svg";